import clsx from 'clsx';
import React, { JSX } from 'react';
import IHeading from '~/data/strapi/types/shared-components/heading';
import TitleTag from '~/enums/title-tag';
import sanitizeHtml from '~/utils/sanitize-html';

import styles from './styles.module.css';

interface Props {
  data?: IHeading;
  className?: string;
  styleAs?: TitleTag;
  htmlTag?: TitleTag;
  title?: string;
  anchor?: string;
}

const TAG_STYLES: Record<string, string> = {
  [TitleTag.H1]: styles.h1,
  [TitleTag.H2]: styles.h2,
  [TitleTag.H3]: styles.h3,
  [TitleTag.H4]: styles.h4,
  [TitleTag.H5]: styles.h4,
  [TitleTag.DIV]: styles.h2,
};

const Heading: React.FC<Props> = ({ className, styleAs, data: strapiData, htmlTag, title, anchor }) => {
  const text = strapiData?.title || title;
  const tag = strapiData?.htmlTag || htmlTag || TitleTag.H2;
  const id = strapiData?.anchor || anchor;

  if (!text) return null;

  const Tag = tag.toLowerCase() as keyof JSX.IntrinsicElements;
  const styleClass = TAG_STYLES[styleAs || tag] || styles.h2;

  return (
    <Tag
      id={id || undefined}
      className={clsx(styles.title, styleClass, className)}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }}
    />
  );
};

export default Heading;
